module.exports = __webpack_public_path__ + "img/handholdIdCard.952d139c.png";